import { render, staticRenderFns } from "./_3.vue?vue&type=template&id=68a27dc8&"
import script from "./_3.vue?vue&type=script&lang=js&"
export * from "./_3.vue?vue&type=script&lang=js&"
import style0 from "./_3.vue?vue&type=style&index=0&id=68a27dc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports